import { useMemo, useState } from 'react';
import { DataGridPro, GridDensity, useGridApiRef } from '@mui/x-data-grid-pro';
import { useFetchDeductionsQuery } from '@api/Trinium/Endpoints/Settlements/slice';
import { GenericOverlay } from '@components/DataGrid/GenericNoRowsOverlay';
import BrandLinearProgress from '@/Infrastructure/Components/Loading/BrandLinearProgress';
import { DeductionsToolbar } from './Toolbar';
import { columns } from './types';
import { settlementsGridSx, settlementsRowHeight } from '../gridStyles';
import { IStatementTab } from '../types';

export default function DeductionsTab(props: IStatementTab) {
  const { data: deductions, isFetching } = useFetchDeductionsQuery({
    terminalNumber: props.terminalNumber,
    statementId: props.statementId
  });
  const apiRef = useGridApiRef();
  const [density, setDensity] = useState<GridDensity>('compact');

  const rows = useMemo(() => deductions ?? [], [deductions]);

  return (
    <DataGridPro
      apiRef={apiRef}
      columns={columns}
      rows={rows}
      loading={isFetching}
      density={density}
      onDensityChange={setDensity}
      rowHeight={settlementsRowHeight}
      showToolbar
      disableRowSelectionOnClick
      initialState={{
        columns: { columnVisibilityModel: { deductionType: false } }
      }}
      slots={{
        toolbar: DeductionsToolbar,
        loadingOverlay: BrandLinearProgress,
        noRowsOverlay: () => <GenericOverlay overlayText='No Deductions Found.' />
      }}
      sx={settlementsGridSx}
    />
  );
}
